







import Vue from 'vue';
import { createNamespacedHelpers } from 'vuex';
import PageLeftHook from '@/components/mixins/PageLeftHook.vue';
import PageFetchHook from '@/components/mixins/PageFetchHook';
import store from '@/store';
import * as CvSectionLinkItemStoreEdit from '@/store/modules/cvSectionLinkItemEdit';
import EditContainer from '@/containers/cv-section-link-item/edit.vue';

const { mapGetters } = createNamespacedHelpers(
  CvSectionLinkItemStoreEdit.namespace
);

const fetch = async params => {
  const { cv_id, cv_section_link_id, id } = params;
  await store.dispatch(
    CvSectionLinkItemStoreEdit.GetCvSectionLinkItem.namespaced({
      params: { cv_id, cv_section_link_id, id },
    })
  );
};

export default Vue.extend({
  components: {
    EditContainer,
  },
  mixins: [PageLeftHook, PageFetchHook(fetch)],
  data() {
    return {
      storeList: [CvSectionLinkItemStoreEdit],
    };
  },
  computed: {
    ...mapGetters(['cvSectionLinkItem']),
  },
});
